<div class="login-pnl">
    <form [formGroup]="loginFrm" (ngSubmit)="onSubmit()" novalidate class="ctr"  autocomplete="off" role="presentation">
        <div *ngIf="invalidAuth" class="row">
          <div class="warning">Login ou Senha inválidos!</div>
        </div>

        <div class="row">
            <input name="login" formControlName="usuario" class="form-control" placeholder="Login">
        </div>

        <div class="row prelative">
            <input placeholder="Senha" formControlName="senha" class="form-control" name="senha" [type]="hide ? 'password' : 'text'">
            <a (click)="toogleViewPassChange()" class="view-password"><fa-icon [icon]="hide ? faEyeSlash : faEye"></fa-icon></a>
        </div>

        <div class="row">
            <mat-checkbox id="ckManterlogado" formControlName="ckManter">Permanecer logado</mat-checkbox>
        </div>

        <button class="btn btn-primary" type="submit">Acessar</button>
    </form>
</div>
